export default __webpack_public_path__ + "static/media/review1.27a0233b.png";